/* ==========================================================================
   Thunala — mega menu hiện ngay khi rê chuột

   Ella làm chậm ở assets/details-disclosure.js:566-576 (DropdownDetails):

     transitionIn()
       opacity 0→1   duration 0.3s, DELAY 0.2s     ← chờ 200ms mới bắt đầu
       translateY   -20% → 0, duration 0.6s        ← trượt xuống 600ms

   Tổng cộng khách phải chờ ~0.5s mới đọc được menu. macorner hiện tức thì.

   Không sửa được bằng CSS: Motion.animate dùng Web Animations API, animation
   nằm ở tầng cascade cao hơn author style thường. Muốn thắng phải `!important`
   trên cả opacity/visibility/transform — làm vậy là khoá cứng, lần sau không ai
   ghi đè được nữa.

   Nên vá bằng cách thay hai hàm trên prototype của RIÊNG <details is="mega-menu-details">.
   DropdownDetails còn là cha của dropdown localization, search, menu thường —
   sửa thẳng lớp cha là đổi tốc độ của tất cả.
   ========================================================================== */

(function () {
  'use strict';

  // 0.12s: đủ để mắt không thấy giật, vẫn cảm giác tức thì.
  var SPEED = 0.12;
  // Trượt rất ngắn thay cho -20% của Ella. Bỏ hẳn thì menu "nhảy" ra hơi thô.
  var SLIDE = '-0.4rem';

  function speed() {
    return window.theme && theme.config && theme.config.motionReduced ? 0 : SPEED;
  }

  customElements.whenDefined('mega-menu-details').then(function () {
    var MegaMenu = customElements.get('mega-menu-details');
    if (!MegaMenu || typeof Motion === 'undefined') return;

    MegaMenu.prototype.transitionIn = function () {
      var panel = this.elements && this.elements.dropdown;
      if (!panel || !panel.firstElementChild) return;

      Motion.animate(
        panel,
        { opacity: [0, 1], visibility: 'visible', overflow: 'visible' },
        { duration: speed(), easing: 'ease-out' }
      );
      return Motion.animate(
        panel.firstElementChild,
        { transform: ['translateY(' + SLIDE + ')', 'translateY(0)'] },
        { duration: speed(), easing: 'ease-out' }
      ).finished;
    };

    MegaMenu.prototype.transitionOut = function () {
      var panel = this.elements && this.elements.dropdown;
      if (!panel || !panel.firstElementChild) return;

      Motion.animate(
        panel,
        { opacity: 0, visibility: 'hidden', overflow: 'hidden' },
        { duration: speed(), easing: 'ease-out' }
      );
      return Motion.animate(
        panel.firstElementChild,
        { transform: 'translateY(' + SLIDE + ')' },
        { duration: speed(), easing: 'ease-out' }
      ).finished;
    };
  });
})();
